<template>
	<div class="auth-social" :class="{'auth-social-checkout': mode == 'checkout', 'auth-social-login': mode == 'login', 'auth-social-register': mode == 'register'}">
		<BaseCmsLabel class="auth-social-headtitle" tag="div" code="login_subtitle_socials" />
		
		<div class="auth-social-buttons">
			<BaseAuthSocialLogin v-slot="{socialLogin, loadingFacebook, loadingGoogle}">	
				<div class="auth-social-item auth-social-item-facebook" :class="{'loading': loadingFacebook}" @click="socialLogin('Facebook')"><UiLoader v-if="loadingFacebook" /><span>Facebook</span></div>
				<div class="auth-social-item auth-social-item-google" :class="{'loading': loadingGoogle}" @click="socialLogin('Google')"><UiLoader v-if="loadingGoogle" /><span>Google</span></div>
			</BaseAuthSocialLogin>
		</div>

		<BaseCmsLabel class="auth-social-subtitle" tag="div" code="social_login_note" />
	</div>
</template>

<script setup>
	const props = defineProps(['mode']);
</script>
3
<style lang="less" scoped>
	.auth-social-headtitle, .auth-social-subtitle{
		font-size: 24px; line-height: 32px; font-weight: normal; padding: 0 0 12px;
		@media (max-width: @t){font-size: 20px; line-height: 26px; padding-bottom: 10px;}
		@media (max-width: @tp){font-size: 18px; line-height: 23px;}
	}
	.auth-social-subtitle{
		padding: 32px 0 12px;
		@media (max-width: @t){padding: 20px 0 10px;}
	}

	.auth-social-buttons{display: flex; align-items: center; gap: 10px; width: 100%;}
	.auth-social-item{
		flex: 1 1 50%; height: 60px; margin: 0; min-width: unset; position: relative; display: flex; align-items: center; justify-content: center; border: 1px solid var(--borderColor); border-radius: 2px; cursor: pointer; font-size: 0; line-height: 18px; background: #fff; transition: border-color 0.3s;
		span{display: block; position: relative;}
		&.loading{
			background-image: url(/assets/images/loader.svg); background-size: 20px; background-repeat: no-repeat; background-position: center; pointer-events: none; cursor: default;
			span{
				color: var(--white);
				&:before{content: none;}
			}
		}
		@media (min-width: @h){
			&:hover{border-color: var(--textColor);}
		}
		@media (max-width: @t){height: 50px;}
	}
	.auth-social-item-facebook{
		span{
			width: 91px; height: 18px;
			&:before{width: 100%; height: 100%; display: block; content: ""; background: url(assets/images/facebook.svg) center no-repeat; background-size: cover; flex-grow: 0; flex-shrink: 0; position: absolute; left: 0;}
			@media (max-width: @tp){width: 71px; height: 14px;}
		}
	}
	.auth-social-item-google{
		span{
			width: 73px; height: 24px;
			&:before{width: 100%; height: 100%; display: block; content: ""; background: url(assets/images/google.svg) center no-repeat; background-size: cover; flex-grow: 0; flex-shrink: 0; position: absolute; left: 0;}
			@media (max-width: @tp){width: 61px; height: 20px;}
		}
	}
	


	//CHECKOUT
	/*.auth-social-checkout{
		@media (max-width: @tp){
			.auth-social-headtitle{padding: 12px 0; line-height: 16px;}
			.auth-social-subtitle{padding: 16px 0 12px; line-height: 16px;}
		}
	} */
</style>